import { render, staticRenderFns } from "./courseralogin.vue?vue&type=template&id=2880c2dc&"
import script from "./courseralogin.vue?vue&type=script&lang=js&"
export * from "./courseralogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports